import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ipsc',
  templateUrl: './ipsc.component.html',
  styleUrls: ['./ipsc.component.scss']
})
export class IpscComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/ipsc/ipsc.component.ts